var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticStyle:{"margin":"18px"}},[_c('v-btn',{on:{"click":_vm.OpenAddFAQs}},[_vm._v("Add Faqs")]),_c('app-add-faqs',{ref:"GetCourseDetailsList",attrs:{"dialog":_vm.AddFAQDialog},on:{"close":_vm.CloseDialog}}),_c('app-faqs-table')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }